module.exports = __webpack_public_path__ + "img/device-windows-mobile-49d04f7382cebf11efd49a832dbbad5a.svg";